import { Link } from 'react-router-dom';
import { Shield, Lock, Flame, ArrowRight, Fingerprint, RefreshCw, EyeOff, PenLine, Share2, Users } from 'lucide-react';
import PageNav from '../components/PageNav';
import Footer from '../components/Footer';

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageNav />
      <section className="relative px-4 pt-16 sm:pt-24 pb-14 text-center max-w-2xl mx-auto animate-fade-in">
        <div className="inline-flex items-center gap-2 bg-burner-500/10 border border-burner-500/20 rounded-full px-4 py-1.5 text-xs text-burner-400 font-medium mb-6"><Shield size={14} />Privacy-first compatibility</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-100 leading-[1.1] mb-5 tracking-tight">
          Share who you are<br/><span className="bg-gradient-to-r from-burner-400 to-burner-600 bg-clip-text text-transparent">without showing your hand.</span>
        </h1>
        <p className="text-gray-400 text-base sm:text-lg mb-8 max-w-md mx-auto leading-relaxed">
          Answer honest questions. Get a SIGPRINT-encoded compatibility code. Share it with a match — see if you're aligned without exposing raw answers.
        </p>
        <Link to="/login" className="btn-gradient inline-flex items-center gap-2 text-white font-semibold px-8 py-3.5 rounded-xl text-base">Try It Free <ArrowRight size={18} /></Link>
      </section>

      <section className="px-4 pb-14 max-w-4xl mx-auto">
        <h2 className="text-center section-label mb-8">How It Works</h2>
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
          {[
            {s:'01',icon:<PenLine size={22}/>,t:'Answer',d:'Fill in topic modules — intimacy, lifestyle, values, dealbreakers.'},
            {s:'02',icon:<Users size={22}/>,t:'Link',d:'Share your Profile ID + a one-time code with a match.'},
            {s:'03',icon:<Fingerprint size={22}/>,t:'Encode',d:'Fresh SIGPRINTs are generated per pair. Non-reversible. Unique to you two.'},
            {s:'04',icon:<Share2 size={22}/>,t:'Compare',d:'See compatibility signals by topic. No raw answers exposed — ever.'},
          ].map(x=>(
            <div key={x.s} className="glass p-5 glass-hover">
              <div className="flex items-center gap-3 mb-3"><span className="text-[10px] font-bold text-burner-500/50 tracking-wider">{x.s}</span><div className="w-10 h-10 rounded-xl bg-burner-500/10 border border-burner-500/15 flex items-center justify-center text-burner-400">{x.icon}</div></div>
              <h3 className="text-sm font-semibold text-gray-100 mb-1.5">{x.t}</h3><p className="text-xs text-gray-400 leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-4 pb-14 max-w-3xl mx-auto">
        <div className="grid grid-cols-2 gap-3">
          {[
            {icon:<EyeOff size={20}/>,l:'Private',d:'Nothing leaves your device'},
            {icon:<Lock size={20}/>,l:'Pair-Bound',d:'Codes are unique per match'},
            {icon:<RefreshCw size={20}/>,l:'Disposable',d:'Burn old codes, generate new'},
            {icon:<Fingerprint size={20}/>,l:'20-char SIGPRINT',d:'14 data + 6 checksum'},
          ].map(x=>(
            <div key={x.l} className="glass-sm p-4 flex items-start gap-3 glass-hover">
              <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-burner-500/10 border border-burner-500/15 flex items-center justify-center text-burner-400">{x.icon}</div>
              <div><p className="text-sm font-semibold text-gray-100">{x.l}</p><p className="text-xs text-gray-500 mt-0.5">{x.d}</p></div>
            </div>
          ))}
        </div>
      </section>

      <section className="px-4 pb-20 text-center">
        <div className="glass max-w-sm mx-auto p-8">
          <p className="text-3xl mb-3">{'\u{1F525}'}</p>
          <h3 className="text-lg font-bold text-gray-100 mb-2">Ready to encode?</h3>
          <p className="text-sm text-gray-400 mb-6">No account needed. No data stored.</p>
          <Link to="/login" className="btn-gradient inline-flex items-center gap-2 text-white font-semibold px-8 py-3 rounded-xl">Get Started <ArrowRight size={18} /></Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
